/***
 * File name: landingPage.js
 *
 * Program Description:
 * Landing page header in dashboard
 *
 */
const landingPage = {
  header: 'Welcome to DBNMS!'
}

export default landingPage
